import i18n, { TFunction } from "i18next";
import { initReactI18next } from "react-i18next";
import { useUserStore } from "src/store";
import enTranslations from "./locales/en/en.json";
import frTranslations from "./locales/fr/fr.json";

export const PREFERRED_LANG_KEY = "preferredLang";
export const DEFAULT_LANG = "en-EN";
export const LANGUAGES = {
  "en-EN": "English",
  "fr-FR": "Français"
};

// the translations
const resources = {
  en: {
    translation: enTranslations
  },
  fr: {
    translation: frTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: DEFAULT_LANG,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export function saveLang(lang: string, updateLocalStorage: boolean = true) {
  const currentLang = useUserStore.getState().lang;
  if (currentLang === lang) {
    return;
  }

  let newLang: string;
  if (lang.startsWith("en")) {
    newLang = "en-EN";
  } else if (lang.startsWith("fr")) {
    newLang = "fr-FR";
  } else {
    newLang = DEFAULT_LANG;
  }

  i18n.changeLanguage(newLang);
  useUserStore.getState().updateLang(newLang);
  if (updateLocalStorage) {
    localStorage.setItem(PREFERRED_LANG_KEY, newLang);
  }
}

export function translate(t: TFunction<"translation", undefined>, key: string, params: any[]): string {
  const args = Object.create(null);
  if (params && params.length > 0) {
    for (let i = 0; i < params.length; i++) {
      args[`p${i}`] = params[i];
    }
  }
  let translated = t(key, args) as string;

  translated = translated.replace(/\{\{p\d+\}\}/g, '');
  translated = translated.trim();

  return translated;
}

export function translateHtml(t: TFunction<"translation", undefined>, key: string, params: any[] = [], className: string = "", surrondByP: boolean = true): React.ReactNode {
  const args = Object.create(null);
  if (params) {
    for (let i = 0; i < params.length; i++) {
      args[`p${i}`] = params[i];
    }
  }
  const str = t(key, args) as string;
  const split = str.split("\n");
  return split.map((line, index) => {
    if (line.trim() === "") {
      return <br key={"translate-html-" + index} />;
    }
    if (surrondByP) {
      return <p key={"translate-html-" + index} className={className}>{line}</p>;
    } else {
      return <span key={"translate-html-" + index} className={className}>{line}</span>;
    }
  });
}

export function textToHTML(text: string, className: string = "", surrondByP: boolean = true): React.ReactNode {
  const split = text.split("\n");
  return split.map((line, index) => {
    if (line.trim() === "") {
      return <br key={"translate-html-" + index} />;
    }
    if (surrondByP) {
      return <p key={"translate-html-" + index} className={className}>{line}</p>;
    } else {
      return <span key={"translate-html-" + index} className={className}>{line}</span>;
    }
  });
}

export function replaceI18n(t: TFunction<"translation", undefined>, text: string): string {
  return text.replace(/\$i18n\((.*?)\)/gm, (_: string, key: string) => t(key));
}

export default i18n;